<div class="menu-icon">
  <span pTooltip="{{tooltip | translate}}"
        tooltipPosition="{{tooltipPosition}}"
        [attr.aria-label]="tooltip | translate"
        class="menu-icon_tooltip"
        (click)="toggleMenu($event)">
    <i class="{{icon}} {{iconClass}} pointer"></i>
  </span>
  <p-tieredMenu #menu [model]="menuItems"
                [popup]="true"
                styleClass="{{tieredMenuStyles}}"
  ></p-tieredMenu>
</div>
